import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppEnvironmentBadge } from '@/components';
import { AppFloatingConfigurator } from '@/layout/components';

@Component({
    selector: 'app-simple-layout',
    standalone: true,
    imports: [CommonModule, RouterModule, AppEnvironmentBadge, AppFloatingConfigurator],
    template: `
        <div class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-screen overflow-hidden">
            <app-floating-configurator />
            <div class="flex flex-col items-center justify-center">
                <div style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
                    <div
                        class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center justify-center text-center relative"
                        style="border-radius: 53px"
                    >
                        <div class="absolute top-6 right-6 z-10">
                            <app-environment-badge />
                        </div>
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class AppSimpleLayout {}
